// eslint-disable-next-line import/no-unresolved
import KeenSlider from "https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js";

const { config } = window.BAO.Carousel;
const { setInitialised, addWheelControls, useArrows, useDots } =
  window.BAO.Carousel.plugins;
class ProductMediaCarousel extends window.BAO.CustomElement() {
  static get requiredElements() {
    return ["slides", "slide", "next", "previous", "dot"];
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.els?.slide?.elements?.length < 2) return;
    this.carousel = this.setupCarousel();
  }

  setupCarousel() {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: "snap",
        defaultAnimation: {
          duration: config.defaultAnimation.duration,
        },
        dragSpeed: config.dragSpeed,
        slides: {
          perView: 1,
        },
      },
      [
        setInitialised(),
        addWheelControls("horizontal"),
        useArrows({
          previous: this.els.previous.element,
          next: this.els.next.element,
        }),
        useDots(this.els?.dot?.elements),
      ],
    );
  }
}

if (!customElements.get("product-media-carousel")) {
  customElements.define("product-media-carousel", ProductMediaCarousel);
}
